<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Progress Project's Budget 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend
                        ><span class="pt-2 mr-2">Dimension</span></b-input-group-prepend
                        >
                        <b-form-select
                        v-model="model.DimCol"
                        :plain="true"
                            :options="dimension"
                        :state="!$v.model.DimCol.$error"
                        ></b-form-select>
                        <b-form-input
                        readonly style="width:50% !important;"
                        v-model="model.DimVal"
                        placeholder="Dimension Value"
                        :state="!$v.model.DimVal.$error"
                        class="ml-1"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuDimShow = true">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label >{{ model.DimColText }}</label></b-input-group-prepend>
                        <b-form-input v-model="model.DimValText" readonly></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <div class="report-wraper">
                    <table width="100%">
                        <thead>
                           <tr>
                            <th rowspan="2" style="max-width:20px; text-align:center; padding-left:2px; padding-right:2px;">No</th>
                            <th style="min-width:500px" rowspan="2">Description</th>
                            <th style="text-align:center; max-width:100px;" rowspan="2">Unit</th>
                            <th style="text-align:center; max-width:70px;" rowspan="2">QTY</th>
                            <th style="text-align:center; max-width:70px;" rowspan="2">Repe-tition</th>
                            <th width="100px" style="text-align:center;" rowspan="2">BUDGET</th>
                            <th width="100px" style="text-align:center;" rowspan="2">REQUESTED</th>
                            <th width="100px" style="text-align:center;" rowspan="2">BALANCE</th>
                <th colspan="6" style="text-align: center">
                  DETAIL REQUESTED/USAGE
                </th>
              </tr>
              <tr>
                <th width="100px" style="text-align: center">PO/SO</th>
                <th width="100px" style="text-align: center">AP INVOICE</th>
                <th width="100px" style="text-align: center">INVENTORY</th>
                <th width="100px" style="text-align: center">ADVANCE</th>
                <th width="100px" style="text-align: center">ADV STTL</th>
                <th width="100px" style="text-align: center">EXPENSE</th>
              </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in budgetLines" :key="row.pjxbudgkey" >
                            <td style="max-width:20px; padding-left:2px; padding-right:0;">{{idx+1}}</td>
                             <td>{{row.jccostname}} &nbsp; &nbsp; {{row.uraian}}</td>
                             <td>{{row.unitsize}}</td>
                             <td>{{row.quantity |numFormat}}</td>
                             <td><span v-if="(row.repetit_qty)">{{row.repetit_qty}} | {{row.repetit_nm}}</span></td>
                             <td style="text-align:right;">{{row.budgetamt |numFormat}}</td>
                              <td style="text-align:right;"><b-link @click="lineDetail(row,'')">{{row.totalreq |numFormat}}</b-link></td>
                              <td style="text-align:right;">{{row.budgetost |numFormat}}</td>
                              <td style="text-align:right;"><b-link @click="lineDetail(row,'PURCHASE ORDER')">{{(row.pottl) |numFormat}}</b-link></td>
                              <td style="text-align:right;"><b-link @click="lineDetail(row,'AP INVOICE')">{{(row.apttl) |numFormat}}</b-link></td>
                              <td style="text-align:right;"><b-link @click="lineDetail(row,'INVENTORY USAGE')">{{(row.invttl) |numFormat}}</b-link></td>
                              <td style="text-align:right;"><b-link @click="lineDetail(row,'CASH ADVANCE')">{{row.cattl |numFormat}}</b-link></td>
                              <td style="text-align:right;"><b-link @click="lineDetail(row,'ADVANCE SETTLEMENT')">{{row.capjttl |numFormat}}</b-link></td>
                              <td style="text-align:right;"><b-link @click="lineDetail(row,'EXPENSE REIMBURSMENT')">{{row.ecttl |numFormat}}</b-link></td>
                            </tr>
                            <tr>
                             <td class="subtotal"></td>
                             <td colspan="4" class="subtotal" style="text-align:right;">Total </td>
                             <td class="grdtotal" style="text-align:right;">{{model.budgettotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.usedtotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.osttotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.pototal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.apinvttl | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.invtotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.catotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.capjtotal | numFormat}}</td>
                             <td class="grdtotal" style="text-align:right;">{{model.ectotal | numFormat}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

              </b-card>    
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="showDetail" size="xl" title="Budget Usage Detail" header-bg-variant="primary"  ok-only>
            <b-card no-body>
                <template v-slot:header >    
                    <b-row>
                        <b-col md="12" >
                            <b-input-group>
                                <b-input-group-prepend><label>Costing Item</label></b-input-group-prepend>
                                <b-form-input readonly v-model="record.jccostname" style="width:35% !important;"></b-form-input>
                                <b-input-group-prepend><span class="p-2">Amount</span></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="record.budgetamt" :precision="2" disabled></my-number>
                                <b-form-checkbox v-model="record.noncash" :value="1" :unchecked-value="0"  class="pt-2">Non CASH</b-form-checkbox>
                            </b-input-group>
                        </b-col>
                    </b-row>         
                    <b-row >
                        <b-col md="12">
                            <b-input-group>
                                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                                <b-form-textarea :rows="2" :max-rows="5" v-model="record.uraian" readonly></b-form-textarea>
                            </b-input-group>
                        </b-col>
                    </b-row>          
                </template>

            <b-table
            class="mb-0"
            ref="tblLineDetail"
            responsive
            striped hover
            style="font-size:smaller;" 
            :items="lineDetails"
            :fields="lineFields"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"                
            >
                <template v-slot:empty>
                  <div class="text-center p-3 text-muted">Tidak ada data detail penggunaan budget</div>
                </template>
                <template v-slot:emptyfiltered>
                  <div class="text-center p-3 text-muted">Tidak ada data transaksi untuk filter ini</div>
                </template>
                <template v-slot:cell(index)="data">
                {{ data.index +1}}
                </template>
                <template v-slot:cell(doc_date)="data">
                {{ data.item.doc_date | moment("DD MMM YYYY")}}
                </template>
                <template v-slot:cell(actualamt)="data">
                {{ data.item.actualamt | numFormat}}
                </template>
            </b-table>
                    <b-row class="mt-1">
                        <b-col lg="7">
                            <b-input-group >
                                <b-input-group-prepend><label >Filter Trx.Source</label></b-input-group-prepend>
                                <b-form-select :options="filterOptions" 
                                    :plain="true" v-model="filter"  />
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col> 
                        <b-col lg="5">
                            <b-input-group>
                                <b-input-group-prepend><span class="p-2">Total {{filter}} :</span></b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="lineTotalval" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col> 
                    </b-row>
            </b-card>
        </b-modal>
    <b-modal
      v-model="lkuDimShow"
      size="lg"
      :hide-footer="true"
      title="List of Dimension Value"
      :centered="true"
    >
      <lku-dim
        @click="onSelectedDim"
        :DimColName="model.DimCol"
        :key="model.DimCol"
      ></lku-dim>
    </b-modal>
    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
 </style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import lkuDim from "../lookup/lkuDim";
import myNumber from "../../components/my-number";
import budgetProject from "../../apis/budgetProject";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, lkuDim, myNumber},
  mixins: [validationMixin],
  validations: {
    model: {
      DimCol: { required },
      DimVal: { required },
    },
  },
  data() {
    return {
        lkuDimShow:false,
        saveEnabled:true,
        updateDimHdr:false,
        uanguser: this.$store.state.user.matauang,
        model:{DimCol:'Dim3',DimColText:'Project Name', DimColInfo:'Project', DimVal:'', DimValInfo:'', DimValText:''},
      isLoading: false,
      reportUrl: null,
      showReport:false,
      budgetLines:[], 
      showDetail:false,
      record:{budgetamt:0},
      filter:'',
      filterOn:['asaltrx'],
      filterOptions: [
        { value: '', text: '-- Semua Transaksi --' },
        { value: 'PURCHASE ORDER', text: 'Purchase Order' },
        { value: 'AP INVOICE', text: 'AP Invoice' },
        { value: 'INVENTORY USAGE', text: 'Inventory Usage' },
        { value: 'CASH ADVANCE', text: 'Cash Advance' },
        { value: 'ADVANCE SETTLEMENT', text: 'Advance Settlement' },
        { value: 'EXPENSE REIMBURSMENT', text: 'Expense Reimbursement' },
      ],
      lineDetails:[],
      lineFields:[
          {
            key: "index",
            thStyle: "width:50px",
            label: "No.",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "doc_date",
            label: "Trx.Date",
          },
          {
            key: "asaltrx",
            label: "Trx.Source",
          },
          {
            key: "doc_no",
            label: "Trx.Number",
          },
          {
            key: "vendorinfo",
            label: "Employee/Vendor",
          },
          {
            key: "remark",
            label: "Trx. Description",
          },
          {
            key: "actualamt",
            thStyle: "width:100px",
            label: "Trx.Value",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "createby",
            label: "Input By",
          },

      ],
      lineTotalval:0,
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
    // this.model.DimCol = this.dimension[0].value;
    this.model.DimCol = 'Dim3';
    this.$watch('model.DimCol', function(newval) {
      console.log('watch DimCol:' , newval )
      this.model.DimVal = "";
      this.model.DimValInfo = "";
      this.model.DimColInfo = this.dimension.find(
        (d) => d.value === newval
      ).text;
      this.model.DimColText = `${this.model.DimColInfo} Name`;
      // console.log('this.model.DimColText:' , this.model.DimColText )
    });            

  },
  methods: {
     onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.lineTotalval=filteredItems.reduce((a, b) => a + b.actualamt, 0);
    },
    clearFilter() {
      this.filter= '';   
    },
    lineDetail: async function(record,asaltrx)
    {
        toastr.success(`Loading Budget Usage Detail "${record.jccostname}", please wait`)
            this.isLoading=true;
            try {
                this.lineTotalval=0;
                this.filter=asaltrx || '';
                this.record=record;
                this.lineDetails= await budgetProject.progressdtl({...this.model,...record});
                if (this.filter) {
                    this.lineTotalval = this.lineDetails
                      .filter(d => (d.asaltrx || '').toUpperCase() === this.filter.toUpperCase())
                      .reduce((a, b) => a + (b.actualamt || 0), 0);
                } else {
                    this.lineTotalval = this.lineDetails.reduce((a, b) => a + (b.actualamt || 0), 0);
                }
                this.showDetail=true;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }

    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                this.reportUrl= await budgetProject.progressprint(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },    
    onSelectedDim: function (_selected) {
      this.model.DimVal = _selected.kode;
      this.model.DimValInfo = `${_selected.kode.trim()} | ${_selected.nama}`;
      this.model.DimValText = _selected.nama;
      this.lkuDimShow = false;
      this.getProgress();
    },
    getProgress:async function () {
          toastr.info('Loading Budget Progress, please wait');
          this.isLoading=true;            
          try {
            const data = await budgetProject.progress(this.model);  
            const row = data[1][0];
            this.saveEnabled=(row.send2wf === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            if (this.dimension) {
                this.dimension.forEach((dim) => {
                    if (this.model[dim.value]) {
                        this.model[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
                    }
                });                
            }
            
            this.budgetLines = data[0];
            // this.calcTotalDtlBudget();
            toastr.clear;
            this.updateDimHdr = !this.updateDimHdr;
            this.isLoading=false;
          } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
          }

    },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'budget.mstrbudgetprogress')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
